/* NEVER LOSE SIGHT — theme interactions */

(function () {
  const header = document.querySelector('[data-nls-header]');
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

(function () {
  const toggle = document.querySelector('[data-nls-mobile-toggle]');
  const menu = document.querySelector('[data-nls-mobile-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      menu.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
})();

(function () {
  const reveals = document.querySelectorAll('.nls-reveal');
  if (!reveals.length || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (!entry.isIntersecting) return;
      setTimeout(() => entry.target.classList.add('is-visible'), index * 80);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  reveals.forEach((el) => observer.observe(el));
})();

(function () {
  const bgText = document.querySelector('[data-nls-hero-bg-text]');
  if (!bgText) return;

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    bgText.style.transform = `translate(-50%, calc(-50% + ${y * 0.25}px))`;
  }, { passive: true });
})();

(function () {
  document.querySelectorAll('.nls-quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      if (!button) return;

      const original = button.textContent;
      button.textContent = 'ADDING…';
      button.disabled = true;

      try {
        const add = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        });
        if (!add.ok) throw new Error('Cart add failed');

        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-nls-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });

        button.textContent = 'ADDED ✦';
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        button.textContent = 'TRY AGAIN';
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
      }
    });
  });
})();

(function () {
  const productRoot = document.querySelector('[data-nls-product-root]');
  if (!productRoot) return;

  const jsonEl = productRoot.querySelector('[data-product-json]');
  const idInput = productRoot.querySelector('[name="id"]');
  const addButton = productRoot.querySelector('button[type="submit"]');
  const priceEl = productRoot.querySelector('[data-nls-product-price]');
  if (!jsonEl || !idInput) return;

  let product;
  try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  const moneyFormat = productRoot.dataset.moneyFormat || '${{amount}}';
  const selected = [];

  product.options.forEach((option, index) => {
    const active = productRoot.querySelector(`[data-option-position="${index + 1}"].is-selected`);
    selected[index] = active ? active.dataset.optionValue : option.values[0];
  });

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  const mainImage = productRoot.querySelector('[data-nls-main-product-media] img');
  const galleryThumbs = productRoot.querySelectorAll('[data-nls-gallery-thumb]');

  function normalizeImageUrl(src) {
    return String(src || '')
      .replace(/^https?:/, '')
      .replace(/_(\d+x|master)(?=\.)/, '')
      .split('?')[0];
  }

  function setMainProductImage(src, alt, mediaId) {
    if (!mainImage || !src) return;

    const finalSrc = String(src).startsWith('//') ? `${window.location.protocol}${src}` : String(src);
    mainImage.src = finalSrc;
    mainImage.removeAttribute('srcset');
    if (alt) mainImage.alt = alt;

    const normalized = normalizeImageUrl(finalSrc);
    let activeThumb = null;

    galleryThumbs.forEach((thumb) => {
      const sameMedia = mediaId && thumb.dataset.mediaId && String(thumb.dataset.mediaId) === String(mediaId);
      const sameImage = normalizeImageUrl(thumb.dataset.full || '') === normalized;
      const active = sameMedia || sameImage;
      thumb.classList.toggle('is-active', active);
      if (active) activeThumb = thumb;
    });

    if (!activeThumb) {
      galleryThumbs.forEach((thumb) => thumb.classList.remove('is-active'));
    }
  }

  function imageFromVariant(variant) {
    const featuredMedia = variant.featured_media || null;
    const featuredImage = variant.featured_image || variant.image || null;

    if (featuredMedia && featuredMedia.preview_image && featuredMedia.preview_image.src) {
      return { src: featuredMedia.preview_image.src, alt: featuredMedia.alt || product.title, mediaId: featuredMedia.id };
    }

    if (featuredMedia && featuredMedia.src) {
      return { src: featuredMedia.src, alt: featuredMedia.alt || product.title, mediaId: featuredMedia.id };
    }

    if (featuredImage && typeof featuredImage === 'object' && featuredImage.src) {
      return { src: featuredImage.src, alt: featuredImage.alt || product.title, mediaId: featuredImage.id };
    }

    if (typeof featuredImage === 'string') {
      return { src: featuredImage, alt: product.title, mediaId: null };
    }

    return null;
  }

  function imageFromSelectedColor() {
    const colorIndex = product.options.findIndex((option) => {
      const name = typeof option === 'string' ? option : option.name;
      return /colo(u)?r/i.test(name || '');
    });

    if (colorIndex < 0 || !selected[colorIndex]) return null;
    const selectedColor = String(selected[colorIndex]).trim().toLowerCase();

    const thumb = Array.from(galleryThumbs).find((item) => {
      return String(item.dataset.alt || '').toLowerCase().includes(selectedColor);
    });

    if (!thumb) return null;
    return { src: thumb.dataset.full, alt: thumb.dataset.alt || product.title, mediaId: thumb.dataset.mediaId || null };
  }

  function updateProductImageForVariant(variant) {
    const match = imageFromVariant(variant) || imageFromSelectedColor();
    if (!match) return;
    setMainProductImage(match.src, match.alt, match.mediaId);
  }

  function sync() {
    const variant = product.variants.find((v) => {
      return v.options.every((option, index) => option === selected[index]);
    });

    if (!variant) return;

    idInput.value = variant.id;

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }

    updateProductImageForVariant(variant);
  }

  productRoot.querySelectorAll('[data-option-value]').forEach((button) => {
    button.addEventListener('click', () => {
      const position = Number(button.dataset.optionPosition);
      selected[position - 1] = button.dataset.optionValue;

      productRoot.querySelectorAll(`[data-option-position="${position}"]`).forEach((el) => {
        el.classList.remove('is-selected');
      });
      button.classList.add('is-selected');

      sync();
    });
  });

  sync();
})();

/* Product media thumbnails */
(function () {
  document.querySelectorAll('[data-nls-product-root]').forEach((root) => {
    const main = root.querySelector('[data-nls-main-product-media] img');
    const thumbs = root.querySelectorAll('[data-nls-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (!full) return;
        main.src = full;
        main.removeAttribute('srcset');
        if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
})();

/* Product card color swatches */
(function () {
  const namedColors = [
    ['washed black', '#171717'], ['vintage black', '#171717'], ['snow wash black', '#1a1a1a'], ['black', '#080808'],
    ['charcoal', '#252525'], ['graphite', '#303030'], ['grey', '#8a8580'], ['gray', '#8a8580'],
    ['white', '#f8f5ed'], ['cream', '#e8dfc9'], ['ivory', '#eee7d8'], ['natural', '#ded2bd'], ['sand', '#c8b99f'], ['beige', '#c8b99f'],
    ['brown', '#5c3a2a'], ['rust', '#8f341f'], ['red', '#8e1f1f'], ['maroon', '#5b121b'],
    ['gold', '#c9a84c'], ['yellow', '#d5b14f'], ['green', '#2f5130'], ['olive', '#51502e'],
    ['blue', '#273f66'], ['navy', '#101d33'], ['purple', '#4f315f'], ['pink', '#c4868e']
  ];

  document.querySelectorAll('[data-color-name]').forEach((swatch) => {
    const raw = (swatch.dataset.colorName || '').trim().toLowerCase();
    if (!raw) return;
    const match = namedColors.find(([name]) => raw.includes(name));
    if (match) swatch.style.setProperty('--nls-swatch-color', match[1]);
  });

  document.querySelectorAll('[data-auto-swatch]').forEach((swatch) => {
    const src = swatch.dataset.imageUrl;
    if (!src) return;
    swatch.style.backgroundImage = `url("${src}")`;

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, Math.floor(img.width / 2), Math.floor(img.height / 2), 1, 1, 0, 0, 1, 1);
        const pixel = ctx.getImageData(0, 0, 1, 1).data;
        swatch.style.backgroundImage = 'none';
        swatch.style.setProperty('--nls-swatch-color', `rgb(${pixel[0]}, ${pixel[1]}, ${pixel[2]})`);
      } catch (error) {
        // Keep the image preview fallback if the browser blocks canvas sampling.
      }
    };
    img.src = src;
  });
})();

/* Change color/size directly from cart */
(function () {
  document.querySelectorAll('[data-nls-cart-item]').forEach((item) => {
    const selects = item.querySelectorAll('[data-nls-cart-option]');
    const jsonEl = item.querySelector('[data-nls-cart-variants]');
    const qtyInput = item.querySelector('[data-nls-cart-quantity]');
    const status = item.querySelector('[data-nls-cart-status]');
    if (!selects.length || !jsonEl || !qtyInput) return;

    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (error) { return; }

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    async function swapVariant() {
      const selectedOptions = Array.from(selects)
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((select) => select.value);

      const variant = variants.find((candidate) => {
        return candidate.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!variant) {
        setStatus('That combination is not available.');
        return;
      }

      if (!variant.available) {
        setStatus('That variant is sold out.');
        return;
      }

      const currentVariantId = String(item.dataset.currentVariantId || '');
      if (String(variant.id) === currentVariantId) {
        setStatus('');
        return;
      }

      const line = Number(item.dataset.line);
      const quantity = Math.max(1, Number(qtyInput.value || 1));
      item.classList.add('is-changing');
      setStatus('Updating…');

      try {
        const removeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        });
        if (!removeRes.ok) throw new Error('Could not remove old variant');

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: quantity })
        });
        if (!addRes.ok) throw new Error('Could not add new variant');

        window.location.reload();
      } catch (error) {
        item.classList.remove('is-changing');
        setStatus('Could not update. Try again.');
      }
    }

    selects.forEach((select) => select.addEventListener('change', swapVariant));
  });
})();

